import { Turbo } from '@hotwired/turbo-rails';

const { StreamActions } = Turbo;

// eslint-disable-next-line func-names
StreamActions.clear = function () {
  this.targetElements.forEach((element) => element.innerHTML = '');
};
